import styled from 'styled-components';
import * as antd from 'antd';

export const AccrualsButton = styled((props) => (
 <antd.Button {...props} type="primary" size="large" />
))`
 background:
  linear-gradient(#fff, #fff) padding-box,
  linear-gradient(
    42.69deg,
    #fff33b -5.54%,
    #fee72e -1.35%,
    #fed51b 6.72%,
    #fdca10 15%,
    #fdc70c 23.9%,
    #f3903f 64.56%,
    #ed683c 87.51%,
    #e93e3a 99.24%
   )
   border-box;
 color: #313149;
 display: block;
 width: 300px;
 font-size: 18px;
 line-height: 18px;
`;

export const SubmitButton = styled((props) => (
 <antd.Button {...props} type="primary" size="large" />
))`
 background:
  linear-gradient(#fff, #fff) padding-box,
  linear-gradient(
    42.69deg,
    #fff33b -5.54%,
    #fee72e -1.35%,
    #fed51b 6.72%,
    #fdca10 15%,
    #fdc70c 23.9%,
    #f3903f 64.56%,
    #ed683c 87.51%,
    #e93e3a 99.24%
   )
   border-box;
 display: block;
 margin-top: 15px;
 color: #313149;
 width: 300px;
 font-size: 18px;
 line-height: 18px;
 position: relative;
 margin-left: 20px;
`;

export const DownloadButton = styled((props) => (
 <antd.Button {...props} type="primary" size="large" />
))`
 background:
  linear-gradient(#fff, #fff) padding-box,
  linear-gradient(
    42.69deg,
    #fff33b -5.54%,
    #fee72e -1.35%,
    #fed51b 6.72%,
    #fdca10 15%,
    #fdc70c 23.9%,
    #f3903f 64.56%,
    #ed683c 87.51%,
    #e93e3a 99.24%
   )
   border-box;
 display: block;
 margin-top: 20px;
 color: #313149;
 width: 200px;
 font-size: 18px;
 line-height: 18px;
 position: relative;
 margin-left: 43%;
`;

export const ContractZoom = styled.div`
 display: none;
 position: absolute;
 right: 22px;
 width: 30px;
 height: 30px;
 z-index: 1;
 cursor: pointer;

 > svg {
  fill: ${(props) => props.theme.orange};
 }
`;

export const Contract = styled.div<{ maximized?: boolean }>`
 position: relative;
 display: flex;
 flex-direction: column;
 flex: ${(props) => (props.maximized ? '1 1 100%' : 'none')};
 overflow: hidden;
 max-width: 300px;
 margin: 20px;
 border-radius: 20px;
 border: 1px solid #ffb614;
 box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
 background: ${(props) =>
  props.maximized
   ? 'linear-gradient(180deg, #76CFF0 0%, #FFFFFF 30.73%)'
   : '#fff'};

 @media (min-width: 880px) {
  flex-direction: row;
  max-width: 100%;
  order: ${(props) => (props.maximized ? -1 : 'auto')};
 }

 ${ContractZoom} {
  display: ${(props) => (props.maximized ? 'block' : 'none')};
  top: 22px;

  @media (min-width: 880px) {
   top: ${(props) => (props.maximized ? 'auto' : '22px')};
   bottom: ${(props) => (props.maximized ? '22px' : 'auto')};
  }
 }

 &:hover {
  border: none;
  background: linear-gradient(180deg, #76cff0 0%, #ffffff 30.73%);

  ${ContractZoom} {
   display: block;
  }
 }
`;
